export const align_right = () => (
  <path
    d="M21 10H7m14-4H3m18 8H3m18 4H7"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
